<template>
  <div class="home">
    <div class="container mx-auto flex">
      <div class="content">
        <h1 class="mb-8 questionnaire-title">
          <strong>Discover what AP automation can take off your plate</strong>
          <span style="display:block">Assess your AP Efficiency</span>
        </h1>
        <div class="text-gray-700">
          <p>
            Take our 3-minute assessment to evaluate your AP processes for efficiency, financial control, and visibility into cash flow.
          </p>
        </div>
        <button class="btn block mt-10" @click="changeSection(0, 1)">Start here</button>
      </div>

    </div>
    <div class="asset" style="background-image: url(./assets/home-image.jpg);">
      <svg xmlns="http://www.w3.org/2000/svg" width="1016.105" height="1108.328" viewBox="0 0 1016.105 1108.328">
        <defs>
          <clipPath id="clip-path">
            <path id="Path_18739" data-name="Path 18739" d="M-10797.172-8324s7.051,15.4,14.932,43.763c21.422,77.124,48.592,250.959-51.086,463.684,1.836.754-45.01,89.019-55.85,280.51-.246,3.084.309,84.574,17.307,119.433.869-2.692,815.117,0,815.117,0h194.344V-8324h-934.764Z" transform="translate(10889.212 8324)" fill="none"/>
          </clipPath>
        </defs>
      </svg>
    </div>

  </div>
</template>

<script>
import store from '../store';

export default {
  name: 'Home',
  methods: {

    // Change path directly by specifying a path and step to switch to
    changeSection: function(path, step) {
      store.dispatch('setActivePath', path);
      store.dispatch('setActiveStep', step);

    }

  },
  setup() {},
};
</script>

<style lang="scss" scoped>

  .content {
    max-width: 100%;

    @media (min-width: $bp-md) {
      max-width: 400px;

    }

    @media (min-width: $bp-lg) {
      max-width: 550px;

    }

    @media (min-width: $bp-xl) {
      max-width: 600px;

    }

  }

  .questionnaire-title {
    font-weight: normal;
    font-size: 25px;
    line-height: 30px;

    strong {
      font-size: 27px;

    }

    @media (min-width: $bp-lg) {
      line-height: 52px;
      font-size: 40px;

      strong {
        font-size: 42px;
        display: block;

      }

    }

  }

  footer {
    padding: 0 7rem;
    position: absolute;
    right: 0;
    bottom: 0;
    left: 0;
    height: 56px;

  }

</style>